import { useCompaniesContext } from "domain/Company";
import { StickerPreview } from "domain/Print";
import { INPUT_FIELD_MAX_LENGTH } from "environment";
import { useEffect, useState } from "react";
import { Button, TextInput } from "shared";

export const UpdateCompanyForm = ({ company, onSubmit, onCancel, isBtnLoading }) => {
  const { companies } = useCompaniesContext();
  const [form, setForm] = useState({ name: company.name, label: company.label });
  const [isValid, setIsValid] = useState(false);
  const [isUnique, setIsUnique] = useState(true);

  useEffect(() => {
    setForm({ name: company.name, label: company.label });
  }, [company]);

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const valid = form.name?.length && form.label?.length && form.label.length <= 10;
    setIsValid(!!valid);

    // jedinstvenost uz ignorisanje trenutno editovane kompanije
    const clash = companies.some(
      (c) => c.id !== company.id && (c.name === form.name || c.label === form.label)
    );
    setIsUnique(!clash);
  }, [form, companies, company.id]);

  const confirm = () => {
    if (!isValid) return alert("Popunite sva polja; labela ≤ 10 karaktera.");
    if (!isUnique) return alert("Naziv i labela moraju biti jedinstveni.");
    onSubmit(form); // parent će pozvati updateCompany(company.id, form)
  };

  return (
    <>
      <div className="update-company">
        <h2 className="update-company__title"> Izmena kompanije</h2>
        <TextInput
          name="name"
          onChange={onInputChange}
          autoComplete="off"
          placeholder="Naziv kompanije"
          value={form.name || ""}
          maxLength={INPUT_FIELD_MAX_LENGTH}
        />
        <TextInput
          name="label"
          onChange={onInputChange}
          autoComplete="off"
          value={form.label || ""}
          placeholder="Naziv labele"
        />
        <StickerPreview
          title={`${form?.label || "?"}-TV-123`}
          subtitle="Samsung TV"
          footer={["Televizor", form?.name || "?"]}
          url="https://inventar.vegait.rs/"
        />
      </div>
      <div className="update-company__controls">
        <Button
          buttonText={"Sačuvaj"}
          buttonColor={"red"}
          event={confirm}
          spinnerColor={"light"}
          isLoading={isBtnLoading}
        />
        <Button buttonText={"Otkaži"} buttonColor={"gray"} event={onCancel} />
      </div>
    </>
  );
};
